




import {Component, Prop, Vue} from "vue-property-decorator";
import {UnitSystem} from "@/interfaces/units";
import {perRoadStore} from "@/store/store";
import {IHistogramBin} from "@/modules/perRoad/lib/calculations/horizontalStrainDistribution";

const echarts = require("echarts");

@Component({
  components: {},
})
export default class PrHorizontalStrainDistributionPlot extends Vue {
  @Prop() percentiles!: number[];

  @Prop() strains!: number[];

  @Prop({default: 0}) id!: string;

  @Prop({default: 0}) externalKey!: number;

  @Prop({default: null}) binnedResults!: IHistogramBin[];

  @Prop({default: null}) rawResults!: number[];

  @Prop({default: null}) resultTable!: {
    uStrain: number
    targetPct: number
    actualPct: number
    isSuccess: boolean
  }[];

  get cumulativeDistributionValues() {
    const sortedValues = this.rawResults.sort((a, b) => b - a);
    const cumulativePct = sortedValues.map((v, i) => i / sortedValues.length);

    return sortedValues.map((v, i) => [v * 1000000, (1 - cumulativePct[i]) * 100]);
  }

  // @PropSync('alternative') alt!: ILccaAlternative;
  plotKeyInternal = 0;

  get plotKey() {
    return this.plotKeyInternal + this.externalKey;
  }

  get unitSystemIsImperial() {
    return perRoadStore.displayUnits === UnitSystem.Imperial;
  }

  sync() {
    this.$emit("sync");
  }

  mounted() {
    // this.createPlotChartJs();
    this.createPlot();
    this.updatePlot();
  }

  // update() {
  //   console.log("update");
  //   this.updatePlot();
  // }

  plotKeyChanged() {
    // this.updatePlot();
  }

  updated() {
    this.createPlot();
    this.updatePlot();
  }

  get plotId() {
    return `${this.id}_strain_dist_plot`;
  }

  chart: any = null;

  // createPlotChartJs() {
  //   // The acceptable region for strain responses
  //   const goodArea = [[300, 95], [this.strains[0], 95]];
  //   goodArea.push(...this.percentiles.map((p, i) => [this.strains[i], p]));
  //   goodArea.push(...[[this.strains[this.strains.length - 1], 0], [0, 0]]);
  //
  //   console.log(goodArea);
  //
  //   // // Boundary line
  //   const boundary = this.percentiles.map((p, i) => [this.strains[i], p]);
  //
  //   // The failure region for strain responses
  //   const failArea = [[300, 95], [this.strains[0], 95]];
  //   failArea.push(...this.percentiles.map((p, i) => [this.strains[i], p]));
  //
  //
  //   const el = document.getElementById(this.plotId);
  //   this.chart = new Chart(el, {
  //     type: "line",
  //     data: {
  //       datasets: [{
  //         label: "Good Area",
  //         data: goodArea.map(xy => {
  //           return {x: xy[0], y: xy[1]};
  //         })
  //       }]
  //     },
  //     options: {
  //       scales: {
  //         y: {
  //           beginAtZero: true
  //         }
  //       }
  //     }
  //   });
  // }

  createPlot() {
    /**
     * There's a weird memory leak with echarts, and it appears to be fixed by forcing echarts to dispose of the chart.
     * Some reports say you have to do chart = null; as well but I'm not sure it matters. Doesn't seem to hurt anything
     * though.
     */
    if (this.chart === null) {
      const el = document.getElementById(this.plotId);
      this.chart = echarts.init(el );
    } else {
      this.chart.dispose();
      this.chart = null;
      const el = document.getElementById(this.plotId);
      this.chart = echarts.init(el );
    }


    this.chart.setOption(
        {
          grid: {
            top: 5,
            right: 5,
            bottom: 45,
            left: 45,
            show: true,
            borderWidth: 1,
            borderColor: "#000",
          },
          tooltip: {
            trigger: "none",
            formatter(obj: any) {
              return `<div>${obj[0].seriesName}:<br> ${obj[0].value[1].toFixed(0)}% > ${obj[0].value[0].toFixed(0)} μStrain</div>`;
            },
          },
          graphic: {
            elements: [
              {
                type: "text",
                position: [120, 50],
                style: {
                  text: "Region of\nacceptable\nperformance",
                  textAlign: "center",
                },

              },
            ],
          },
          xAxis: {
            scale: false,
            min: 0,
            max: 300,
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
            },
            axisLine: {
              show: false,
            },
            name: "μStrain (Tension)",
            nameLocation: "middle",
            nameGap: 30,
          },
          yAxis: {
            name: "Cumulative %",
            nameLocation: "middle",
            nameGap: 30,
            min: 40,
            max: 100,
            axisLabel: {
              show: true,
              // formatter: ,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              location: "left",
              show: true,
              alignWithLabel: true,
            },
            splitLine: {
              show: false,
            },
          },
          series: [
            {
              type: "line",
              lineStyle: {},
              name: "Strain Limit",
              data: null,
              animation: false,
            },
            {
              type: "line",
              symbol: "none",
              lineStyle: {},
              name: "Strain Result",
              data: null,
              animation: false,
            },
            {
              type: "line",
              symbol: "none",
              lineStyle: {
                color: "black",
              },
              name: "Horizontal Strain Values",
              data: null,
              animation: false,
            },
            {
              type: "scatter",
              lineStyle: {},
              name: "Test Points",
              data: null,
              animation: false,
              // itemStyle: {
              //   color: (si, di, d, v) => (v === 1 ? 'blue' : 'red'),
              // },
            },
            {
              type: "line",
              name: "goodArea",
              symbol: "none",
              data: null,
              lineStyle: {
                width: 0,
              },
              areaStyle: {
                origin: "end",
                color: "blue",
                opacity: 0.1,
              },
              animation: false,
            },
            {
              type: "line",
              name: "failArea",
              symbol: "none",
              data: null,
              lineStyle: {
                width: 0,
              },
              areaStyle: {
                origin: "start",
                color: "red",
                opacity: 0.3,
              },
              animation: false,
            },
          ],
        },
    );


  }


  updatePlot() {
    // console.log("Updating chart", this.chart);
    // The acceptable region for strain responses
    const goodArea = [[300, 95], [this.strains[0], 95]];
    goodArea.push(...this.percentiles.map((p, i) => [this.strains[i], p]));
    goodArea.push(...[[this.strains[this.strains.length - 1], 0], [0, 0]]);

    // console.log(goodArea);

    // // Boundary line
    const boundary = this.percentiles.map((p, i) => [this.strains[i], p]);

    // The failure region for strain responses
    const failArea = [[300, 95], [this.strains[0], 95]];
    failArea.push(...this.percentiles.map((p, i) => [this.strains[i], p]));

    const series = [
      {
        name: "goodArea",
        data: goodArea,
      },
      {
        name: "failArea",
        data: failArea,
      },
      {
        name: "Strain Limit",
        data: boundary,
      },
    ];

    if (this.rawResults) {

      const data = this.cumulativeDistributionValues;

      series.push({
        name: "Horizontal Strain Values",
        data,
      });
    }

    if (this.resultTable) {
      series.push({
        name: "Test Points",
        // @ts-ignore
        data: this.resultTable.map((r) => ({
          value: [r.uStrain, r.actualPct],
          itemStyle: {
            color: r.isSuccess ? "green" : "red",
          },
          symbol: r.isSuccess ? "circle" : "triangle",
        })),
      });
    }

    this.chart.setOption({
      series,
    });
  }
}
